module.exports = __webpack_public_path__ + "img/popular-categories-5.0707195e.png";